import { useCheckPaymentExpiration } from '~/components/Inbox/Notification/Reminders/hooks/useCheckPaymentExpiration';

/**
 * Returns whether the effective office can pay — i.e. it has a valid (non-expired)
 * selected payment method (bank accounts are always treated as valid), is pre-approved,
 * or is a parent office. Single source of truth for gating value-added features
 * (invite / auto-confirm) that require payment.
 *
 * Delegation, pre-approval, parent-office and bank-account handling are inherited from
 * `useCheckPaymentExpiration`.
 */
export const useHasValidPaymentMethod = (officeId?: string): boolean => {
  const { isInvalidPayment } = useCheckPaymentExpiration(officeId);
  return !isInvalidPayment;
};
